import { Alert, Button, Checkbox, message, Modal, Select, Space, Typography } from "antd";
import { ApiService } from "api/api.service";
import dayjs from "dayjs";
import { LedgerSchemaDto } from "dtos/ledger.dto";
import { useEffect, useState } from "react";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "America/New_York";

export const ModifyPostingDayModal = ({
  open,
  record,
  onClose,
  onSuccess,
}: {
  open: boolean;
  record: LedgerSchemaDto | null;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  console.log(
    "raw:",
    record?.posting_date,
    "ET day:",
    dayjs(record?.posting_date).tz("America/New_York").format("dddd"),
    "local day:",
    dayjs(record?.posting_date).format("dddd"),
  );
  console.log(
    new Date(record?.posting_date ?? "").toLocaleString("en-US", {
      timeZone: "America/New_York",
      weekday: "long",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }),
  );
  const defaultDay = (() => {
    const day = dayjs(record?.posting_date).utc().day();
    return day === 0 ? 7 : day;
  })();

  const [newDayOfWeek, setNewDayOfWeek] = useState<number>(defaultDay);
  const [cascade, setCascade] = useState<boolean>(false);
  const { mutate, isPending } = ApiService.ledger.useModifyPostingDate();

  useEffect(() => {
    if (open && record) {
      const day = dayjs(record.posting_date).day();
      setNewDayOfWeek(day === 0 ? 7 : day);
      setCascade(false);
    }
  }, [open, record]);

  const handleOk = () => {
    if (!record) return;
    mutate(
      { ledger_id: record._id.toString(), newDayOfWeek, cascade },
      {
        onSuccess: (data) => {
          message.success(data.message);
          onSuccess();
          onClose();
        },
      },
    );
  };

  return (
    <Modal
      open={open}
      title="Modify Posting Day"
      width={700}
      onCancel={onClose}
      onOk={handleOk}
      okText="Update"
      okButtonProps={{ loading: isPending }}
      destroyOnClose
    >
      {record && (
        <Space direction="vertical" size="middle" className="w-full pt-2">
          <Alert
            type="info"
            showIcon
            message={`Current posting day: ${dayjs(record.posting_date).tz(TZ).format("dddd")}`}
          />
          <div>
            <Typography.Text strong>New Posting Day</Typography.Text>
            <Select
              className="mt-2 w-full"
              value={newDayOfWeek}
              onChange={setNewDayOfWeek}
              options={[
                { label: "Monday", value: 1 },
                { label: "Tuesday", value: 2 },
                { label: "Wednesday", value: 3 },
                { label: "Thursday", value: 4 },
                { label: "Friday", value: 5 },
                { label: "Saturday", value: 6 },
                { label: "Sunday", value: 7 },
              ]}
            />
          </div>
          <Checkbox checked={cascade} onChange={(e) => setCascade(e.target.checked)}>
            Apply this posting day to all future rows
          </Checkbox>
          <Typography.Text type="secondary">
            When enabled, all ledger rows after this one will be updated to use the selected posting day.
          </Typography.Text>
        </Space>
      )}
    </Modal>
  );
};
